// What a duplicated project may carry over from its source (Josh, 12 Oct 2026).
//
// These fields are SERVER-OWNED: only Cloud Functions write them (Admin SDK), and
// firestore.rules refuses a client create or update that sets them to anything
// live. Keep this list identical to `serverOwnedProjectFields()` in
// firestore.rules. A copy is a new production: it is never unlocked, never holds a
// Show Pass or a Notes List show pass, and is not linked to Notes List.
//
// Both duplicate paths use this: the dashboard (actions.js duplicateProject) and
// Project Settings (project-settings/nav.vue). The settings panel always wrote the
// RESET values below; the dashboard used to copy the source's fields as they were,
// which handed the copy of a Notes List show-pass show free sync.
export const SERVER_OWNED_PROJECT_FIELDS = [
    'unlocked',
    'passOwnerUID',
    'passAppliedAt',
    'noteslist_show_pass_active',
    'noteslist_show_pass_ref',
    'noteslist_show_pass_payment_intent',
    'noteslist_show_pass_granted_at',
    'noteslist_show_pass_granted_by_partner',
    'noteslist_show_pass_refunded_at',
    'noteslist_show_pass_refunded_ref',
    'noteslist_production_id',
    'noteslist_link_status',
    'noteslist_linked_at',
    'noteslist_webhook_url',
    'noteslist_last_sync_at',
    'noteslist_last_sync_error',
    'noteslist_roster_revision',
    'noteslist_structure_revision',
    'noteslist_last_delivered_revision',
    'noteslist_roster_event_at',
    'noteslist_roster_unmatched'
];

// The values the settings-panel duplicate has always written on the copy.
export const DUPLICATE_RESET_VALUES = {
    noteslist_link_status: 'unlinked',
    noteslist_production_id: null,
    noteslist_show_pass_active: false,
    noteslist_show_pass_ref: null,
    noteslist_show_pass_payment_intent: null,
    noteslist_webhook_url: null,
    noteslist_linked_at: null,
    noteslist_last_sync_at: null,
    noteslist_last_sync_error: null
};

// A shallow copy of `source` without any server-owned field, plus the reset
// values. Never mutates `source` (it is usually a reference into Vuex state).
export function duplicateCopyFields(source) {
    const copy = { ...(source || {}) };
    for (const field of SERVER_OWNED_PROJECT_FIELDS) {
        delete copy[field];
    }
    return { ...copy, ...DUPLICATE_RESET_VALUES };
}

// The duplicator's own per-person settings for the source show (users/{uid}.projects[pid]:
// cue positions, hidden layers, cue box options, cue groups), for the copy they now own.
// Josh, 13 Oct 2026: a collaborator who duplicates gets THEIR view, never the owner's.
// Never mutates `user` (it is the Vuex user).
export function duplicatorProjectSettings(user, projectId, now) {
    const own = (user && user.projects && user.projects[projectId]) || null;
    return {
        ...(own || {}),
        dashboardHide: false,
        lastChangedDate: now.toISOString()
    };
}



// WEBPACK FOOTER //
// ./src/lib/duplicate-project-fields.js